// promoCode.js
import React, { useState } from "react";

const PromoCode = () => {
  const [showCopied, setShowCopied] = useState(false);

  const handleCopyLink = () => {
    const promoText = "LYDIA";
    navigator.clipboard
      .writeText(promoText)
      .then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        onClick={handleCopyLink}
        className="button-styles hover-text promo-code"
        translate="no"
        lang="en"
      >
        {/* Tooltip visible al pasar el mouse */}
        <span className="tooltip-text fade">Copy promo code</span>
        {/* Texto que se copia */}
        LYDIA
      </button>
      {showCopied && (
        <div
          style={{
            position: "absolute",
            top: "calc(80% + 2px)",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
            width: "120px",
            whiteSpace: "nowrap",
            color: "var(--font-description-color)",
            fontSize: "12px",
            backgroundColor: "var(--tooltip-color)",
            borderRadius: "10px",
            padding: "6px 16px",
          }}
        >
          Promo Code copied!
        </div>
      )}
    </div>
  );
};

export default PromoCode;
